import FinanceAdapter from './base';

export default class CostCentre extends FinanceAdapter {
  modelNamePlural = 'costCentres';
}
